export default __webpack_public_path__ + "static/media/13_cloud 2.6be244f9.gif";